import {searchModel} from "../../../../Utilities/Search";

export const ownLoanHistorySearchModel = (patronId = "", shippingLocationId = "", ownCatalogTitle = "", ownLoanStatus = "", isOwnLoanHistory = true, districtId = "", organization = "") => {
    return Object.assign({}, searchModel(patronId.toString(), "ownCatalogTitle", false, "ownCatalogTitle"), {
        patronId,
        shippingLocationId,
        ownCatalogTitle,
        ownLoanStatus,
        isOwnLoanHistory,
        districtId,
        organization,
        ClearLoanHistorySearch: clearOwnLoanHistorySearch,
    });
};

function clearOwnLoanHistorySearch(this: Record<string, unknown>) {
    this.ownCatalogTitle = "";
    this.patronId = "";
    this.shippingLocationId = "";
    this.ownLoanStatus = "";
    this.districtId = "";
    this.organization = "";
    (this as { ClearSearch: (load: boolean) => void }).ClearSearch(false);
}
